// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "path.react-flow__edge-path{stroke:#c5cfd8;stroke-width:2}.edgebutton{width:20px;height:20px;background:#eee;border:1px solid #fff;cursor:pointer;border-radius:50%;font-size:12px;line-height:1}.edgebutton:hover{box-shadow:0 0 6px 2px rgba(0,0,0,0.08)}.edgebutton-foreignobject div{background:transparent;width:40px;height:40px;display:flex;justify-content:center;align-items:center;min-height:40px}\n", ""]);
// Exports
module.exports = exports;
